module.exports = __webpack_public_path__ + "static/img/tyjr.84011f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/tyjr.png
// module id = o3MR
// module chunks = 44